import React from "react";

interface DuplicateOutLineIconProps {
  className?: string;
  size?: number;
}

const DuplicateOutLineIcon: React.FC<DuplicateOutLineIconProps> = ({
  className = "",
  size = 18,
}) => {
  return (
    <svg
      className={className}
      width={`${size}px`}
      height={`${size}px`}
      viewBox="0 0 512 512"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="128"
        y="128"
        width="336"
        height="336"
        rx="57"
        ry="57"
        stroke="#9BB6C2"
        strokeWidth="32"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="M383.5,128l.5-24a56.16,56.16,0,0,0-56-56H112a64.19,64.19,0,0,0-64,64V328a56.16,56.16,0,0,0,56,56h24"
        stroke="#9BB6C2"
        strokeWidth="32"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <line
        x1="296"
        y1="216"
        x2="296"
        y2="376"
        stroke="#9BB6C2"
        strokeWidth="32"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <line
        x1="376"
        y1="296"
        x2="216"
        y2="296"
        stroke="#9BB6C2"
        strokeWidth="32"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </svg>
  );
};

export default DuplicateOutLineIcon;
